import type { UserQuestProgress } from "Infrastructure/Api/Api";
import { useResource } from "Infrastructure/Translations/Resources";
import { useRequestStatusConfig } from "./useRequestStatusConfig";

export const useRequestStatus = (status: UserQuestProgress) => {
  const { t } = useResource();
  const statusConfig = useRequestStatusConfig();

  const config = statusConfig[status];

  return {
    label: t(config.labelKey),
    color: config.colorKey,
  };
};
